import { Grid, Typography } from "@mui/material";
import type { ReactNode } from "react";

const COLUMN_SIZE = {
  2: { xs: 12, sm: 6 },
  3: { xs: 12, sm: 6, md: 4 },
} as const;

type Props = {
  label: string;
  value?: ReactNode;
  columns?: 2 | 3;
};

export const GridItem = ({ label, value, columns = 3 }: Props) => (
  <Grid size={COLUMN_SIZE[columns]}>
    <Typography variant="body2" color="text.secondary" mb={0.5}>
      {label}
    </Typography>
    {/* value is any ReactNode — a div (Chip, …) inside a <p> is invalid HTML. */}
    <Typography component="div">{value || "-"}</Typography>
  </Grid>
);
